import { call } from "./use"

//
// useChartConfig manages chart configurations for a controller by merging
// default settings with user preferences. It initializes the configuration
// using default values and user-specified parameters from the URL. The
// function ensures proper data types and removes undefined values. It also
// listens for view change events to update and cache configurations. Methods
// for setting and disconnecting configurations are added to the controller,
// providing a straightforward approach to handling dynamic configurations.
//
export const useChartConfig = (controller) => {
  const configs = controller.constructor.configs

  controller.config = {};
  controller.configInputs = {};

  function defaultConfig() {
    return configs?.reduce((acc, {name, default: _default}) => {
      if(name) acc[name] = _default
      return acc
    }, {});
  }

  function setConfig(state = {}) {
    let config = {
      ...defaultConfig(),
      ...(call(controller, "queryContextDefaults") || {}),
      ...(controller.hasChartConfigValue ? controller.chartConfigValue : {}),
      ...state,
    }

    controller.config = config;
    configs?.forEach(({name, type}) => {
      if (type === "json" && typeof controller.config[name] === "string") {
        try {
          controller.config[name] = JSON.parse(controller.config[name])
        } catch(e) {
          console.error(e)
          controller.config[name] = {}
        }
      } else if (type === "boolean") {
        controller.config[name] = controller.config[name] === "true" || controller.config[name] === true
      }

      // remove undefined values
      if(controller.config[name] === undefined) {
        delete controller.config[name]
      }
    });
  }

  Object.assign(controller, {
    setConfig, defaultConfig,
  })
}
